var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLpIntro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 349,
    viewBox: "0 0 601 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1531_62133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.562 94.263C285.854 94.2677 274.529 112.009 258.821 115.767C243.642 119.385 213.915 111.318 201.595 118.43C189.276 125.542 203.25 142.703 196.965 151.456C190.445 160.518 159.748 167.049 159.739 176.695C159.731 179.865 163.022 182.673 167.673 185.358C174.228 189.142 183.509 192.658 190.087 196.455C192.954 198.007 195.278 199.861 196.933 201.919C203.18 210.682 189.177 227.851 201.484 234.956C213.791 242.061 243.532 233.977 258.688 237.596C261.998 238.387 265.13 239.797 268.135 241.532C274.713 245.33 280.802 250.687 287.357 254.472C292.003 257.153 296.901 259.053 302.358 259.055C319.078 259.05 330.391 241.309 346.105 237.555C361.284 233.936 391.011 242.004 403.331 234.892C415.65 227.78 401.676 210.618 407.961 201.865C414.481 192.804 445.179 186.272 445.193 176.623C445.19 173.453 441.904 170.648 437.253 167.963C430.698 164.179 421.411 160.661 414.833 156.863C411.974 155.313 409.66 153.459 408.016 151.403C401.763 142.643 415.773 125.471 403.465 118.365C391.158 111.26 361.429 119.365 346.238 115.738C342.681 114.788 339.475 113.451 336.797 111.799C330.219 108.002 324.13 102.644 317.569 98.8564C312.923 96.1614 308.013 94.2614 302.562 94.263Z",
    fill: "#122640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.873 191.942C314.2 193.084 286.979 195.977 280.613 196.937C274.629 197.851 268.551 198.545 262.416 199.013C257.269 199.431 252.059 199.519 246.881 199.276C242.295 199.017 238.889 198.246 236.661 196.965C232.965 194.831 231.045 192.637 230.901 190.382C230.775 188.048 231.667 185.733 233.493 183.647C235.513 181.306 238.024 179.117 240.971 177.131C244.061 175.016 247.044 173.019 249.919 171.139L252.787 169.258C257.384 166.389 261.355 163.877 264.701 161.72C268.047 159.564 271.077 157.612 273.792 155.864C276.5 154.116 279.037 152.524 281.404 151.087C283.771 149.65 286.223 148.197 288.762 146.727C295.335 142.932 300.757 140.152 305.031 138.385C309.304 136.618 312.617 136.229 314.971 137.217L328.232 142.773C328.615 142.922 328.964 143.071 329.285 143.216C329.605 143.361 329.903 143.52 330.235 143.711C332.397 144.96 333.431 146.292 333.336 147.707C333.285 149.051 332.382 150.339 330.797 151.327L266.498 184.146L267.934 184.863L471.733 151.048C472.894 150.629 474.202 150.364 475.561 150.272C477.113 150.166 478.686 150.231 480.194 150.464C481.889 150.716 483.524 151.085 485.067 151.561C486.742 152.078 488.272 152.738 489.605 153.519C493.297 155.651 495.505 157.791 496.23 159.94C496.955 162.089 496.138 163.846 493.779 165.213C492.075 166.21 490.125 167.057 487.994 167.727C485.665 168.439 483.254 169.059 480.778 169.58C478.039 170.171 474.922 170.788 471.455 171.435",
    fill: "#FFBC01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.699 254.316L274.46 263.691",
    stroke: "url(#paint0_linear_1531_62133)",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.999935,
    width: 62.2156,
    height: 62.2902,
    rx: 7,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 489.886 177.786)",
    stroke: "url(#paint1_linear_1531_62133)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.999935,
    width: 62.2156,
    height: 62.2902,
    rx: 7,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 113.194 104.963)",
    stroke: "url(#paint2_linear_1531_62133)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.55 120.85L163.361 107.104C167.187 104.895 173.391 104.895 177.217 107.104L199.254 119.826",
    stroke: "url(#paint3_linear_1531_62133)",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.496 87.9912L318.097 98.0359",
    stroke: "url(#paint4_linear_1531_62133)",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.999935,
    width: 62.2156,
    height: 62.2902,
    rx: 7,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 248.682 247.469)",
    stroke: "url(#paint5_linear_1531_62133)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.999935,
    width: 62.2156,
    height: 62.2902,
    rx: 7,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 363.655 40.6299)",
    stroke: "url(#paint6_linear_1531_62133)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.144 225.481L432.114 242.24C428.287 244.449 422.083 244.449 418.257 242.24L404.33 234.2",
    stroke: "url(#paint7_linear_1531_62133)",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1531_62133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.258 137.204C127.711 136.675 127.549 136.019 126.784 135.578L114.04 128.22C113.275 127.778 112.15 127.692 111.223 127.946L101.865 130.566L92.585 135.924C91.947 136.292 91.9464 136.894 92.5836 137.262L93.7422 137.931C94.3795 138.299 95.4228 138.299 96.0608 137.93L97.2208 137.261L111.124 145.287L109.964 145.957C109.326 146.325 109.326 146.927 109.963 147.295L111.121 147.964C111.759 148.332 112.802 148.332 113.44 147.963L122.72 142.606L127.258 137.204ZM102.439 136.255C101.477 135.7 101.478 134.803 102.441 134.247C103.403 133.691 104.957 133.691 105.918 134.246C106.88 134.801 106.879 135.698 105.916 136.254C104.954 136.81 103.4 136.81 102.439 136.255ZM112.866 142.275C111.904 141.72 111.905 140.823 112.868 140.267C113.831 139.711 115.384 139.711 116.346 140.266C117.308 140.821 117.307 141.718 116.344 142.274C115.381 142.829 113.828 142.83 112.866 142.275ZM107.44 131.107L112.125 129.793L124.047 136.676L121.772 139.381L107.44 131.107Z",
    fill: "url(#paint8_linear_1531_62133)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1531_62133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.225 83.6297L378.579 76.4979C379.53 75.9488 379.798 75.1255 379.277 74.4096L373.72 66.9158C373.384 66.4675 372.77 66.113 371.993 65.9192L359.013 62.7111C357.784 62.417 356.346 62.5781 355.407 63.1206L343.053 70.2523C341.777 70.9889 341.776 72.1936 343.05 72.9293L346.526 74.9359L356.966 68.9091L368.552 75.5978L358.112 81.6246L361.588 83.6312C362.863 84.367 364.949 84.3663 366.225 83.6297Z",
    fill: "url(#paint9_linear_1531_62133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.573 75.3188C364.812 75.0618 364.767 74.7547 364.428 74.5585L358.763 71.2885C358.423 71.0923 357.897 71.0694 357.446 71.2046L352.901 72.5918L348.261 75.2704C347.942 75.4545 347.913 75.739 348.196 75.9025L348.711 76.1998C348.994 76.3633 349.487 76.3464 349.806 76.1622L350.386 75.8274L356.565 79.3947L355.985 79.7295C355.666 79.9137 355.637 80.1981 355.92 80.3616L356.435 80.6589C356.718 80.8224 357.211 80.8055 357.53 80.6213L362.17 77.9428L364.573 75.3188ZM352.898 75.2688C352.471 75.0221 352.515 74.5986 352.996 74.3207C353.477 74.0428 354.211 74.0176 354.638 74.2644C355.066 74.5111 355.022 74.9346 354.541 75.2125C354.059 75.4904 353.326 75.5156 352.898 75.2688ZM357.533 77.9443C357.105 77.6976 357.149 77.2741 357.63 76.9962C358.112 76.7183 358.845 76.6931 359.273 76.9398C359.7 77.1866 359.657 77.6101 359.175 77.888C358.694 78.1659 357.96 78.1911 357.533 77.9443ZM355.508 72.7575L357.783 72.0622L363.082 75.1212L361.878 76.4348L355.508 72.7575Z",
    fill: "url(#paint10_linear_1531_62133)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1531_62133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.374 208.736L505.216 208.067L507.535 206.727L505.218 205.39L502.898 206.729L493.629 201.378L495.949 200.039L493.632 198.701L491.312 200.04L490.154 199.371C488.867 198.629 486.804 198.643 485.528 199.38L469.277 208.748C468.662 209.103 468.316 209.585 468.315 210.087C468.315 210.589 468.66 211.07 469.274 211.425L485.495 220.789C486.769 221.525 488.856 221.524 490.132 220.788L506.371 211.413C507.647 210.676 507.649 209.471 506.374 208.736ZM487.815 219.45L471.594 210.086L483.194 203.389L499.414 212.753L487.815 219.45ZM483.188 208.743L480.871 207.406L483.191 206.066L485.508 207.404L483.188 208.743ZM487.823 211.419L485.506 210.081L487.826 208.742L490.143 210.079L487.823 211.419ZM492.457 214.094L490.14 212.757L492.46 211.417L494.777 212.755L492.457 214.094ZM478.549 211.422L476.231 210.084L478.551 208.745L480.868 210.083L478.549 211.422ZM483.183 214.097L480.866 212.76L483.186 211.42L485.503 212.758L483.183 214.097ZM487.817 216.773L485.5 215.435L487.82 214.096L490.137 215.434L487.817 216.773Z",
    fill: "url(#paint11_linear_1531_62133)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1531_62133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.383 272.398C252.987 268.706 242.6 268.709 236.197 272.405C229.794 276.102 229.788 282.098 236.184 285.791C242.579 289.483 252.967 289.479 259.37 285.783C265.773 282.086 265.779 276.09 259.383 272.398ZM242.353 284.115L240.137 285.394L237.044 283.609L239.283 282.316C237.719 280.931 237.315 279.225 239.438 277.852L241.709 279.163C240.607 279.933 240.49 280.964 242.61 282.188C244.881 283.499 246.527 283.137 247.235 282.728C248.198 282.173 248.593 281.356 246.624 279.509C244.446 277.449 243.66 275.629 246.038 274.256C248.033 273.104 250.943 273.284 253.365 274.187L255.603 272.894L258.697 274.68L256.435 275.986C258.068 277.531 257.51 279.098 255.805 280.162L253.534 278.851C254.763 278.075 254.961 277.171 253.131 276.114C251.393 275.111 249.561 274.964 248.448 275.607C247.473 276.17 247.588 276.973 249.326 278.672C251.063 280.371 252.556 282.399 249.633 284.086C247.499 285.305 244.752 285.058 242.353 284.115Z",
    fill: "url(#paint12_linear_1531_62133)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1531_62133",
    x: 28.707,
    y: 18.4727,
    width: 543.867,
    height: 330.401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.294118 0 0 0 0 0.223529 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1531_62133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1531_62133",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1531_62133",
    x1: 291.132,
    y1: 254.566,
    x2: 283.014,
    y2: 268.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1531_62133",
    x1: 32.1078,
    y1: 0,
    x2: 32.1078,
    y2: 64.2902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1531_62133",
    x1: 32.1078,
    y1: 0,
    x2: 32.1078,
    y2: 64.2902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1531_62133",
    x1: 184.772,
    y1: 111.465,
    x2: 169.404,
    y2: 138.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1531_62133",
    x1: 335.929,
    y1: 88.2412,
    x2: 327.231,
    y2: 103.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1531_62133",
    x1: 32.1078,
    y1: 0,
    x2: 32.1078,
    y2: 64.2902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1531_62133",
    x1: 32.1078,
    y1: 0,
    x2: 32.1078,
    y2: 64.2902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1531_62133",
    x1: 450.717,
    y1: 219.461,
    x2: 432.74,
    y2: 250.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1531_62133",
    x1: 120.412,
    y1: 131.899,
    x2: 111.133,
    y2: 147.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1531_62133",
    x1: 373.028,
    y1: 66.3254,
    x2: 362.675,
    y2: 84.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1531_62133",
    x1: 361.595,
    y1: 72.9235,
    x2: 356.956,
    y2: 80.9596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1531_62133",
    x1: 500.584,
    y1: 202.714,
    x2: 488.986,
    y2: 222.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1531_62133",
    x1: 259.383,
    y1: 272.398,
    x2: 247.785,
    y2: 292.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122640",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1531_62133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.1078,
    height: 32.1451,
    fill: "white",
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 112.309 120.524)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1531_62133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.1078,
    height: 32.1451,
    fill: "white",
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 362.773 56.1914)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1531_62133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.1078,
    height: 32.1451,
    fill: "white",
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 489 193.349)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1531_62133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.1078,
    height: 32.1451,
    fill: "white",
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 247.801 263.031)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLpIntro);
export default __webpack_public_path__ + "static/media/icon-lp-intro.4ff40ac1d0fd8599b8a27430e502b523.svg";
export { ForwardRef as ReactComponent };